import React from 'react';
import { connect } from 'react-redux';

import { fromFilter } from 'store/selectors';
import { setFilterMiddleware } from 'store/actions';

import { FilterCheckbox } from 'components';

const FilterCheckboxContainer = props => <FilterCheckbox {...props} />;

const mapStateToProps = (state, { filter, middleware, defaultValue }) => {
  const storeValue = fromFilter.getFilterMiddleware(state, filter, middleware);
  return {
    checked: typeof storeValue === 'undefined' ? defaultValue : storeValue,
  };
};

const mapDispatchToProps = (dispatch, { filter, middleware }) => ({
  onChange: ({ target: { checked } }) => dispatch(setFilterMiddleware(filter, middleware, checked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterCheckboxContainer);



// WEBPACK FOOTER //
// ./src/containers/FilterCheckbox.js